import { css } from 'styled-components';
import { breakpoints } from '../../breakpoints';
import { cssfonts } from '../cssfonts';

const common = css`
  font-size: 2rem; /* 32px */
  line-height: 1.25; /* 32/40 */

  @media (min-width: ${breakpoints.desktop}) {
    font-size: 2.75rem; /* 44px */
    line-height: 1.2; /* 44/52 */
  }
`;

export const h3 = {
  extrabold: css`
    ${cssfonts.exbold}
    ${common}
  `,
  bold: css`
    ${cssfonts.bold}
    ${common}
  `,
  regular: css`
    ${cssfonts.regular}
    ${common}
  `,
  light: css`
    ${cssfonts.light}
    ${common}
  `,
} as const;

